import React, { useState } from "react";
import List from "../reliefList";
import Filter from "../reliefFilter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import Breadcrumb from "../../../utils/breadCrumbs";
import * as XLSX from "xlsx";
import moment from "moment-timezone";
import { getDateTimeZone } from "../../../../utils/formats";
import * as ReliefServices from "../../../../services/ReliefServices";

const queryClient = new QueryClient();

const ReliefFilterListContainer = (props) => {
  const { t } = useTranslation();

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.relief.list") },
  ];
  const [filters, setFilters] = useState(undefined);

  const handlerCleanFilter = async (resetForm) => {
    resetForm();
    setFilters(undefined);
  };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });

    setFilters(newFilter);
  };

  const exportToExcel = async () => {
    const filter = {
      filters,
      sort: "createdAt",
    };
    ReliefServices.listToExport(filter).then((result) => {
      const data = result.map((relief) => {
        return {
          A: relief.turnData?.initDate
            ? getDateTimeZone(relief.turnData?.initDate)
            : "-",
          B: relief.turnData?.endDate
            ? getDateTimeZone(relief.turnData?.endDate)
            : "-",
          C: relief.dataUser?.email || "-",
          D: relief.nextTurnData?.dataUser?.email || "-",
          E: relief.read ? "Si" : "No",
          F: relief.createdAt ? getDateTimeZone(relief.createdAt) : "-",
          G: relief.updatedAt ? getDateTimeZone(relief.updatedAt) : "-",
          H: relief.dataUserModified?.email || "-",
          I: relief.observations || "-",
        };
      });
      data.unshift({
        A: "Fecha Inicio",
        B: "Fecha Fin",
        C: "Trabajador",
        D: "Trabajdor siguiente turno",
        E: "Leido",
        F: "Fecha de creación",
        G: "Actualizado por última vez",
        H: "Modificado por última vez por",
        I: "Observaciones",
      });

      const filename = `Relevos_export_${moment(new Date()).format(
        "DDMMyyyyHHmm",
      )}`;
      const sheetName = "Listado de relevos";
      var ws = XLSX.utils.json_to_sheet(data, {
        header: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });
      ws["!cols"] = [
        { wch: 18 },
        { wch: 18 },
        { wch: 30 },
        { wch: 30 },
        { wch: 10 },
        { wch: 18 },
        { wch: 18 },
        { wch: 30 },
        { wch: 100 },
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename + ".xlsx");
    });
  };

  return (
    <>
      <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.relief.list")}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            onSubmit={handlerOnSubmitFilter}
            onClean={handlerCleanFilter}
          />
        </div>
      </div>
      <div className="row justify-content-center no-margin">
        <div className="col-12 col-md-11 mt-3 text-end">
          <button
            type="button"
            className="btn btn-md btn-secondary"
            onClick={() => exportToExcel()}
          >
            <i className="fa-solid fa-file-excel icon-button"></i>{" "}
            {t("exportFileExcel")}
          </button>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <QueryClientProvider client={queryClient}>
            <List className="marg-top-1rem" filters={filters} />
          </QueryClientProvider>
        </div>
      </div>
    </>
  );
};

ReliefFilterListContainer.propTypes = {};

export default ReliefFilterListContainer;
